/*
 * Copyright (c) 2021, Closinglock, LLC.
 * All rights reserved.
 */
import jQuery from 'jquery';

(function ($) {
    ('use strict');

    /* ---------------------------------------------- /*
     * Preloader
    /* ---------------------------------------------- */

    $(window).on('load', function () {
        $('.layout').addClass('fade-in');
    });

    $(document).ready(function () {
        /* ---------------------------------------------- /*
         * Setting background of modules
        /* ---------------------------------------------- */

        $('[data-background]').each(function () {
            $(this).css('background-image', 'url(' + $(this).attr('data-background') + ')');
        });

        $('[data-background-color]').each(function () {
            $(this).css('background-color', $(this).attr('data-background-color'));
        });

        // AJW: Needed to make drop downs in navigation menu work on hover. See submenu-fix.js and on('resize')
        $(document).resize();

        /* ---------------------------------------------- /*
         * Scroll top
        /* ---------------------------------------------- */

        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('.scroll-top').addClass('scroll-top-visible');
            } else {
                $('.scroll-top').removeClass('scroll-top-visible');
            }
        });

        $('a[href="#top"]').on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
        });
    });
})(jQuery);
